import { Box } from '@mui/system';
import { useDroppable } from '@dnd-kit/core';
import DeleteIcon from '@mui/icons-material/Delete';
import { Team } from '../types';
import { useMemo } from 'react';

type BenchProps = {
  team: Team;
  children?: React.ReactNode;
};

export const Bench = ({ team, children }: BenchProps) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `bench-${team.name}`,
    data: {
      team,
    },
  });
  const { isOver: isDeleteOver, setNodeRef: setDeleteNodeRef } = useDroppable({
    id: `trash-${team.name}`,
  });

  const style = useMemo(
    () =>
      ({
        width: 600,
        position: 'relative',
        marginTop: 40,
        height: 50,
        borderLeft: `1px solid ${isOver ? '#ef5e21' : '#000'}`,
        borderBottom: `1px solid ${isOver ? '#ef5e21' : '#000'}`,
        borderRight: `1px solid ${isOver ? '#ef5e21' : '#000'}`,
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
      }) as const,
    [isOver]
  );

  const trashStyle = {
    visibility: isOver || isDeleteOver ? 'visible' : 'hidden',
    position: 'absolute',
    bottom: 0,
    right: 0,
    padding: 10,
  } as const;

  return (
    <Box style={style} ref={setNodeRef}>
      {children}
      <Box style={trashStyle} ref={setDeleteNodeRef}>
        <DeleteIcon
          color={isDeleteOver ? 'error' : 'inherit'}
          fontSize="medium"
        />
      </Box>
    </Box>
  );
};
